
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.69 7.202a.43.43 0 00.62 0l5.387-5.11c.182-.174.182-.454 0-.594l-.728-.7c-.146-.175-.437-.175-.619 0l-4.332 4.13L1.65.797a.43.43 0 00-.619 0l-.728.7c-.182.14-.182.42 0 .595l5.388 5.11z","fill":"#000","fill-opacity":".6"}})])
          )
        }
      }
    